import { MailOutlined, PhoneOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import React from "react";
import { Company, Loading } from "../../../helpers/shared-interfaces";
import {
  getCompanyEmail,
  getCompanyPhoneNumber,
} from "../../../helpers/utilities";
import { ItemClickProps } from "../GlobalFormModal";
import NoData from "../NoData";

type Props = {
  loading: Loading;
  handleRetry: () => void;
  companies: Company[];
  onCompanyClick: (item: ItemClickProps) => void;
};

export default function Companies({
  companies,
  loading,
  handleRetry,
  onCompanyClick,
}: Props): JSX.Element {
  return (
    <div className="global-results">
      {loading === Loading.INITIAL ? null : loading === Loading.LOADING ? (
        <div className="loading-container">
          <div className="loading-spinner">
            <Spin size="default" />
          </div>
        </div>
      ) : loading === Loading.ERROR ? (
        <div className="error-container">
          <p>Something went wrong</p>
          <button onClick={handleRetry}>Try again</button>
        </div>
      ) : companies.length === 0 ? (
        <div className="no-results">
          <NoData />
          <p>No Data</p>
        </div>
      ) : (
        companies.map((company) => (
          <div
            key={company.id}
            className="search-result"
            role="presentation"
            onClick={() =>
              onCompanyClick({
                id: company.id,
                type: "company",
                segment: "companies",
                data: company,
              })
            }
          >
            <div className="result-content">
              <div className="result-title">{company.name}</div>
              <div className="result-details">
                <MailOutlined />
                {getCompanyEmail(company)} {" / "}
                <PhoneOutlined /> {getCompanyPhoneNumber(company)}
              </div>
            </div>
            <span className="right-arrow">→</span>
          </div>
        ))
      )}
    </div>
  );
}
